
















import { Teacher } from '../../../src_server/entity/generated/Teacher';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import CommonTable, { TableColumn } from '../../components/organisms/CommonTable.vue';

import { DailyReportService } from '../../biz/remote/DailyReportService';
import { ReportDTO } from '../../../src_server/entity/dto/ReportDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { routeHelper } from '../../utils/routeHelper';
import PrimaryButton from '../../components/button/PrimaryButton.vue';
import { dayjs, DTW_FORMAT_JA_SHORT } from '../../../src_server/common/momentExtends';
import { URIs } from '../../../src_server/common/URIs';
import { Session } from '../../utils/Session';

@Component({ components: { CommonDialog, CommonTable } })
export default class ReportLogDialog extends Vue {
  private teacher: Teacher = new Teacher();
  private list: ReportDTO[] = [];

  private get title() {
    return this.teacher.nickname + `さんの日報履歴`;
  }

  public cols: TableColumn[] = [
    { label: 'no', type: 'seq', width: '75px' },
    {
      label: '日報を開く',
      type: 'button',
      width: '120px',
      btnClass: PrimaryButton.CSS,
      onclick: this.openReport,
    },
    {
      label: '日付',
      name: 'lessons.start_dt',
      formatFunc: (value: any) => {
        return dayjs(value).format(DTW_FORMAT_JA_SHORT);
      },
      width: '120px',
    },
    { label: 'ニックネーム', name: 'studentNickname', width: '125px' },
    { label: '本日のゴール', name: 'report.lesson_goal', width: '10%' },
    { label: 'ゴール達成の3つのポイント', name: 'report.lesson_point', width: '10%' },
    { label: '本日のゴール達成率', name: 'report.goal_rate', width: '10%' },
    { label: 'どうすれば100%になる？', name: 'report.student_state', width: '10%' },
    { label: '次回までの宿題', name: 'report.homework', width: '10%' },
    { label: '保護者への一言', name: 'report.to_parent' },
    { label: '主体性', name: 'strengthLinner.S01Initiatives' },
    { label: '働きかけ力', name: 'strengthLinner.S02ForceToWork' },
    { label: '実行力', name: 'strengthLinner.S03Execution' },
    { label: '課題発見力', name: 'strengthLinner.S04DiscoverIssues' },
    { label: '計画力', name: 'strengthLinner.S05Planning' },
    { label: '創造力', name: 'strengthLinner.S06Creativity' },
  ];

  async loadData(teacher: Teacher) {
    console.log('test');
    if (!teacher.user_id) {
      await MessageDialog.systemError('先生のユーザーID', '日報履歴表示時');
      return;
    }

    const biz = new DailyReportService();
    const response = await biz.getTeacherReportList(teacher.user_id);
    this.list = response.data.sort((a, b) => {
      if (a.studentNickname !== b.studentNickname) {
        // 文字列は大小で比較する必要がある
        if (a.studentNickname! > b.studentNickname!) return 1;
        if (a.studentNickname! < b.studentNickname!) return -1;
      }
      return dayjs(b.lessons.start_dt).diff(dayjs(a.lessons.start_dt));
    });
  }

  async openReport(row: any) {
    if (Session.isCircleOBuilding()) {
      routeHelper(this, 'AdminDailyReportPage', { class_id: `${row.lessons.class_id}` });
    } else {
      routeHelper(this, 'DaAdminDailyReportPage', { class_id: `${row.lessons.class_id}` });
    }
  }

  async csvExport() {
    const url = `${URIs.REPORT_CSV_DOWNLOAD.path}?teacher_user_id=${this.teacher.user_id}&token=${Session.getJwtToken()}`;
    location.href = url;
  }

  /**
   * 表示
   */
  public show(row: Teacher) {
    this.teacher = row;
    this.loadData(row).then();

    const dialog = this.$refs['teacher_report_log_dialog'] as CommonDialog;
    dialog.show();
  }

  /**
   * 隠す
   */
  hide() {
    const dialog = this.$refs['teacher_report_log_dialog'] as CommonDialog;
    dialog.hide();
  }
}
